import { Button } from '@/components/ui/button';
import { UserPlus, X } from 'lucide-react';

interface CandidateBulkActionBarProps {
  count: number;
  onAssign: () => void;
  onClear: () => void;
}

export function CandidateBulkActionBar({ count, onAssign, onClear }: CandidateBulkActionBarProps) {
  if (count === 0) return null;

  return (
    <div
      role="region"
      aria-label="Bulk actions"
      className="fixed bottom-6 left-1/2 z-40 flex -translate-x-1/2 items-center gap-3 rounded-full border border-border bg-card px-4 py-2 shadow-lg animate-in slide-in-from-bottom-4 fade-in-0 duration-200"
    >
      <span className="text-sm font-medium text-foreground">
        {count} selected
      </span>
      <div className="h-5 w-px bg-border" aria-hidden />
      <Button size="sm" onClick={onAssign} className="gap-1.5">
        <UserPlus className="h-4 w-4" />
        Assign to vacancy
      </Button>
      <Button
        variant="ghost"
        size="icon"
        className="h-8 w-8 text-muted-foreground"
        onClick={onClear}
        aria-label="Clear selection"
      >
        <X className="h-4 w-4" />
      </Button>
    </div>
  );
}
